import {EntityModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {CourseDefinitionData} from "./course-definition.data";

@Injectable()
export class CourseDefinitionEntityModel extends EntityModel<CourseDefinitionData> {
    constructor(injector: Injector) {
        super(injector, CourseDefinitionData)
    }

    override getResourceName(): string {
        return "course-definition";
    }

    override getResource(): string {
        return "course";
    }
}
